<template>
    <transition name="slide-fade">
        <div class="dialog-view" v-if="visible">
            <div class="u-window">
                <div class="dialog-content">
                    <div class="u-btn close" @click="closeModal"></div>
                    <div class="dialog-wrapper area-modal" v-if="!submit">
                        <div class="dialog-title t-area"></div>
                        <div class="area-view">
                            <div class="area-box" :class="{'show' : listShow}">
                                <p class="now" @click="listShow = !listShow"><span>选择大区</span>{{ now.name }}<em
                                        class="select"></em></p>
                                <div class="area-list" v-if="listShow">
                                    <vuescroll>
                                        <ul>
                                            <li v-for="area in areas[account_type]" :key="area.id"
                                                v-bind:data-aid="area.id" v-bind:data-name="area.name"
                                                @click="queryPlayer" v-html="area.name"></li>
                                        </ul>
                                    </vuescroll>
                                </div>
                            </div>
                            <div class="player-name">
                                <p><span>角色昵称</span>{{ now.playerName }}</p>
                            </div>
                        </div>
                        <p class="warn"><em class="i-warn"></em>绑定大区后不可修改。</p>
                        <div class="u-btn submit" @click="now.playerName ? submit = true : $toast('请选择有角色的大区')"></div>
                    </div>

                    <div class="dialog-wrapper bind-confirm" v-if="submit">
                        <div class="dialog-title t-area-comfirm"></div>
                        <div class="bind-info">
                            <div class="content">
                                <p class="name">【{{ now.playerName }}】即将绑定<b>【{{ now.name }}】</b></p>
                                <p>绑定后不可更改！！！</p>
                            </div>
                        </div>
                        <div class="u-ctrl comfirm flex-center-start">
                            <div class="u-btn cancel" @click="submit = false;"></div>
                            <div class="u-btn submit" @click="bindArea"></div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="u-mask"></div>
        </div>
    </transition>
</template>

<script>
    import {
        apiUserBind,
        apiUserQuery,
    } from '@/api/index';

    export default {
        name: 'area-modal',
        data: function () {
            return {
                listShow: false,
                submit: false,
                now: {
                    "id": 0,
                    "name": "",
                    "playerName": '',
                },
                areas: {
                    pc: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 23,
                        "name": "单刀赴会"
                    }],
                    wg: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    }, {
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    }],
                    steam: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 21,
                        "name": "长生殿(Steam)"
                    }, ],
                    test: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    }, {
                        "id": 21,
                        "name": "长生殿(Steam)"
                    }, {
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    }, {
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 100,
                        "name": "TEST_1"
                    }, {
                        "id": 110,
                        "name": "TEST_2"
                    }],
                },
                from: {
                    '1': 'wg',
                    '2': 'steam',
                    '0': 'pc',
                },
                visible: false,
                account_type: 'pc',
                code: '',
                ua: {},
                busy: false,
            }
        },
        watch: {
            closed(newVal) {
                if (newVal) {
                    this.visible = false
                    this.destroyElement()
                }
            }
        },
        created() {
            document.body.style.overflow = 'hidden';
            this.account_type = process.env.NODE_ENV == 'development' ? 'test' : this.from[this.$store.state.userinfo
                .fromType ? this.$store.state.userinfo.fromType.toString() : '0'];
            //this.account_type = 'test'
            this.$disableScroll();
        },
        methods: {
            destroyElement() {
                document.body.style.overflow = ''; // 出现滚动条
                this.$enableScroll();
                this.$destroy()
                this.$el.parentNode.removeChild(this.$el)
            },
            closeModal() {
                this.destroyElement()
            },
            queryPlayer(e) {
                this.listShow = false;
                var _s = e.target;
                var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');

                apiUserQuery({
                    zid: vue.now.id
                }).then(
                    res => {
                        vue.$toast('查询成功');
                        vue.now.playerName = res.data.nickName;
                    },
                    rej => {
                        vue.$toast(rej.message);
                        vue.now.playerName = '';
                    },
                )

            },
            bindArea(e) {
                var _s = e.target;
                var vue = this;

                if (this.busy) return;

                //todo inviteCode
                if (!vue.now.id) return vue.$toast('请先选择绑定大区');
                if (!vue.now.playerName) return vue.$toast('端游未创角');

                this.busy = true;

                apiUserBind({
                    zid: vue.now.id
                }).then(
                    res => {
                        // vue.$toast('大区绑定成功，即将刷新页面，请稍后');

                        // setTimeout(() => {
                        //     location.reload();
                        // } , 300);

                        vue.$toast('大区绑定成功');

                        vue.$update_evt();
                        // vue.$shop_render();                  

                        this.busy = false;

                        vue.destroyElement();
                    },
                    rej => {
                        this.busy = false;
                        vue.$toast(rej.message);
                    }
                )
            },
        },
    }
</script>

<style lang="scss" scoped>
    .area-modal {
        // width: 656px;
        // height: 437px;
        // background-image: url(~@/assets/images/modal/bg-modal-normal.png);
    }

    .bind-confirm {
        // width: 656px;
        // height: 437px;
        // background-image: url(~@/assets/images/modal/bg-modal-normal.png);

        .bind-info {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 150px;
            line-height: 1.8;
            margin: 50px auto;
            text-align: center;
            color: #3b3f3e;
            b {
                color: #cf3013;
            }

        }
    }


    .dialog-content {
        // padding: 29px 39px;
    }

    .t-area {
        width: 516px;
        height: 51px;
        margin: 0 auto 25px;
        background-image: url(~@/assets/images/modal/title-bind.png);
    }

    .t-area-comfirm {
        width: 516px;
        height: 51px;
        margin: 0 auto 25px;
        background-image: url(~@/assets/images/modal/title-comfirm.png);
    }

    .area-view {
        margin-top: 0;
    }


    .area-view .area-box {

        position: relative;
        width: 530px;
        height: 73px;
        line-height: 73px;
        margin: 0 auto 25px;
        box-sizing: border-box;
        color: #3b3f3e;
        vertical-align: middle;
        border: 1px solid #e1e5d7;
        border-radius: 10px;
        z-index: 10;
        font-size: 24px;
        //background-color: #f5f7ed;

        &.show {
            background-color: #f5f7ed;
            border-radius: 10px 10px 0 0;
        }

    }

    .area-box p {
        position: relative;
        padding-left: 30px;
        line-height: 73px;
    }

    .area-box .now .select {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 20px;
        width: 24px;
        height: 100%;
        transform: translateY(-50%);
    }

    .area-box .now .select::after {
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/modal/icon-select.png);
        background-size: 24px 16px;
        background-position: center;
        background-repeat: no-repeat;
        transition: all .3s ease-in;
    }

    .area-box.show .now .select::after {
        transform: rotate(180deg);
    }

    .area-box .now span {
        padding-right: 20px;
        color: #3b3f3e;
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 71px;
        left: 50%;
        width: 530px;
        height: 250px;
        padding: 20px 15px 60px 15px;
        background-color: #f5f7ed;
        border: 1px solid #e1e5d7;
        color: #3b3f3e;
        z-index: 50;
        box-sizing: border-box;
        transform: translateX(-50%);
        border-top: none;
        border-radius: 0 0 10px 10px;
    }

    .area-view .area-list ul {
        display: flex;
        flex-wrap: wrap;
    }

    .area-view .area-list li {
        /* display: inline-block; */
        min-width: 50%;
        min-height: 30px;
        line-height: 30px;
        margin-bottom: 15px;
        text-align: center;
        box-sizing: content-box;
        cursor: pointer;
    }

    .area-view .player-name {
        position: relative;
        width: 530px;
        height: 73px;
        line-height: 73px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        color: #3b3f3e;
        vertical-align: middle;
        border: 1px solid #e1e5d7;
        border-radius: 10px;
        font-size: 24px;
        //background-color: #f5f7ed;
    }

    .area-view .player-name p {}

    .area-view .player-name span {
        display: inline-block;
        padding-left: 30px;
        padding-right: 20px;
        color: #3b3f3e;
    }


    .area-modal .u-btn.submit {
            width: 205px;
            height: 55px;
        margin: 15px auto 0;
        background-image: url(~@/assets/images/modal/btn-submit.png);
    }

    .u-ctrl.comfirm {
        margin-top: 25px;

        .u-btn.submit {
            width: 205px;
            height: 55px;
            margin: 0 10px 0;
            background-image: url(~@/assets/images/modal/btn-bind.png);
        }

        .u-btn.cancel {
            width: 205px;
            height: 55px;
            margin: 0 10px 0;
            background-image: url(~@/assets/images/modal/btn-re.png);
        }
    }


    .area-modal .warn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        line-height: 1.6;
        color: #cf3013;
        text-align: center;
        font-size: 20px;
    }

    // .i-warn {
    //     display: inline-block;
    //     width: 18px;
    //     height: 18px;
    //     margin-right: 15px;
    //     background-image: url(~@/assets/images/modal/icon-warn.png);
    //     vertical-align: middle;
    // }
</style>